import { WidgetEventStruct } from "../../widget-event.struct";
import { NotificationSettingsWidgetEnum } from "../../../enums";

export class NotificationSettingsWidgetEventStruct extends WidgetEventStruct {
  public event_notification_settings_widget_type: NotificationSettingsWidgetEnum;
}
